export function extractUrlPath(url: string): string {
  try {
    const parsedUrl = new URL(url)

    return `${parsedUrl.pathname}${parsedUrl.search}`
  } catch (error) {
    throw new Error(`Некорректный URL: ${url}`)
  }
}
